import { useEffect } from "react";
import { clearPostLoginPath } from "./postLoginRedirect";

// Rendered once the signed-in app is showing: the remembered page has been reached, so a later sign-in does not
// jump back to it.
export default function ClearPostLoginPath() {
    useEffect(() => {
        clearPostLoginPath();
    }, []);
    return null;
}
